import { Segmented } from 'ui';
import { useCalendarSettings } from '../../../storages';
import { useGetLayoutOptions } from './hooks';

const LayoutNavigator = () => {
  const [{ layout }, setCalendarSettings] = useCalendarSettings();
  const options = useGetLayoutOptions();

  return (
    <Segmented
      onChange={(newLayout) => {
        setCalendarSettings({ layout: newLayout });
      }}
      options={options}
      value={layout}
    />
  );
};

export default LayoutNavigator;
